export function confirm({ params }) {
  return {
    url: `/api/users/${{
      register: 'confirm_email',
      email: 'confirm_new_email',
      phone: 'confirm_new_phone_number',
    }[params.origin] || 'confirm_email'}/${params.token}`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
    },
  }
}

export function profile({ params }) {
  return {
    url: `/api/users/${params.id}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}

export const amend = {
  informations: ({ params, payload }) => ({
    url: `/api/users/${params.id}`,
    method: 'PUT',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  }),
  email: ({ payload }) => ({
    url: `/api/users/request_new_email_confirmation`,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: null,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  }),
  phone: ({ payload }) => ({
    url: `/api/users/request_new_phone_number_confirmation`,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: null,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  }),
  password: () => ({
    url: `/api/users/password/request_update`,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: null,
      'Content-Type': 'application/json',
    },
  }),
}
